import {
  NO_CHANGES_TO_TAXES_IMAGE_BASE_URL,
  SecondhandTaxesLandingPageSection,
} from '../../constants'

export const getQuestionSectionContent = (countryCode = 'UK', isDarkMode = false) => {
  const darkModePrefix = isDarkMode ? 'dark' : 'light'
  const messageImageUrl = `${NO_CHANGES_TO_TAXES_IMAGE_BASE_URL}/${countryCode}/DAC7-illustration-message-242x124-${darkModePrefix}`
  const sofaImageUrl = `${NO_CHANGES_TO_TAXES_IMAGE_BASE_URL}/${countryCode}/DAC7-illustration-sofa-242x124-${darkModePrefix}`

  return {
    componentId: SecondhandTaxesLandingPageSection.Questions,
    testId: 'no-changes-to-taxes--question-section',
    text: {
      title: 'secondhand_taxes.questions.title',
    },
    cards: [
      {
        title: 'secondhand_taxes.questions.item1.title',
        description: 'secondhand_taxes.questions.item1.description',
        link: 'secondhand_taxes.questions.item1.link',
        image: {
          src: `${messageImageUrl}.png`,
          srcSet: `${messageImageUrl}.png 520w, ${messageImageUrl}@2x.png 1040w, ${messageImageUrl}@3x.png 1560w, `,
        },
      },
      {
        title: 'secondhand_taxes.questions.item2.title',
        description: 'secondhand_taxes.questions.item2.description',
        link: 'secondhand_taxes.questions.item2.link',
        image: {
          src: `${sofaImageUrl}.png`,
          srcSet: `
            ${sofaImageUrl}.png 520w,
            ${sofaImageUrl}@2x.png 1040w,
            ${sofaImageUrl}@3x.png 1560w,
            `,
        },
      },
    ],
  }
}
